import { Autocomplete, Chip, TextField } from '@mui/material';
import { UseControllerReturn } from 'react-hook-form';
import { FieldProps } from '@/classes/types';
import Field from '../Field';

export function EmailsComponent({ fieldModel, field, fieldState }: FieldProps<EmailsField>) {
  return (
    <Autocomplete
      multiple
      options={fieldModel.options}
      value={field.value || []}
      onChange={(e, value) => field.onChange(value)}
      freeSolo
      renderTags={(value: readonly string[], getTagProps) =>
        value.map((option: string, index: number) => {
          const { key, ...tagProps } = getTagProps({ index });
          return <Chip variant="outlined" label={option} key={key} {...tagProps} />;
        })
      }
      disabled={fieldModel.disabled}
      size={fieldModel.size}
      renderInput={(params) => (
        <TextField {...fieldModel.getTextFieldProps(fieldState)} {...params} />
      )}
    />
  );
}

export default class EmailsField extends Field {
  options: string[];

  constructor(name: string, options: string[]) {
    super(name);
    this.options = options;
  }

  renderEditComponent(props: UseControllerReturn) {
    return <EmailsComponent {...props} fieldModel={this} />;
  }
}
